// extracted by mini-css-extract-plugin
export var arrowDown = "Outcome-module--arrowDown--7bdbc";
export var arrowUp = "Outcome-module--arrowUp--5fa15";
export var away = "Outcome-module--away--f016f";
export var bottomBorder = "Outcome-module--bottomBorder--f02e6";
export var card = "Outcome-module--card--ccb53";
export var centerAlign = "Outcome-module--centerAlign--29afc";
export var competitor = "Outcome-module--competitor--7d427";
export var container = "Outcome-module--container--46e26";
export var detail = "Outcome-module--detail--dac2f";
export var disabled = "Outcome-module--disabled--edec5";
export var dividerLeft = "Outcome-module--dividerLeft--550b1";
export var dividerRight = "Outcome-module--dividerRight--57b75";
export var draw = "Outcome-module--draw--5791d";
export var enter = "Outcome-module--enter--3fe60";
export var fullWidth = "Outcome-module--fullWidth--0e58d";
export var grid = "Outcome-module--grid--0d1e1";
export var hasDraw = "Outcome-module--hasDraw--71bd9";
export var home = "Outcome-module--home--97998";
export var leftAlign = "Outcome-module--leftAlign--acc55";
export var live = "Outcome-module--live--8d34c";
export var loading = "Outcome-module--loading--4ded7";
export var lost = "Outcome-module--lost--739dc";
export var name = "Outcome-module--name--cbef7";
export var noTopBorder = "Outcome-module--noTopBorder--cc279";
export var odds = "Outcome-module--odds--534a1";
export var oddsContainer = "Outcome-module--oddsContainer--90814";
export var outcome = "Outcome-module--outcome--52eaa";
export var outright = "Outcome-module--outright--8ec59";
export var roundBottomLeft = "Outcome-module--roundBottomLeft--84793";
export var roundBottomRight = "Outcome-module--roundBottomRight--46f1c";
export var row = "Outcome-module--row--13a46";
export var selected = "Outcome-module--selected--7afea";
export var suspended = "Outcome-module--suspended--8b798";
export var unclickable = "Outcome-module--unclickable--df175";
export var won = "Outcome-module--won--a0af5";